// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import { Icon } from '@ta/styleguide.icon';
import { ProtectedObfuscatedLink } from '@ta/social.obfuscation';
import decodeString from '@ta/common.decode';
import { IsMountedClient } from '@ta/common.client';
import styles from './WebsiteLink.less';

type Props = {
  uri: string,
};

const WebsiteLink = ({ uri }: Props) => {
  if (!uri) {
    return null;
  }
  return (
    <IsMountedClient>
      {isClient => {
        const displayLink = isClient ? decodeString(uri) : '';
        let webLink;
        if (/^https?:\/\//.test(displayLink)) {
          webLink = (
            <ProtectedObfuscatedLink
              target="_blank"
              encodedUrl={uri}
              className={`ui_link ${styles.link}`}
            >
              <Icon name="internet" className={styles.icon} />
              {displayLink.replace(/(?:\w+:\/\/)?([\w.]+)(?:\/.*)?/, '$1')}
            </ProtectedObfuscatedLink>
          );
        } else {
          webLink = (
            <ProtectedObfuscatedLink
              target="_blank"
              encodedUrl={uri}
              className={`ui_link ${styles.link}`}
              requiresHttp
            >
              <Icon name="internet" className={styles.icon} />
              {displayLink.replace(/(?:\w+:\/\/)?([\w.]+)(?:\/.*)?/, '$1')}
            </ProtectedObfuscatedLink>
          );
        }
        return webLink;
      }}
    </IsMountedClient>
  );
};

export default WebsiteLink;
